import { create } from 'zustand';
import { IMedwandStore } from './types';
import { medwandApi } from '@/API';
import { convertKeys } from '@/utils/common';
import { TVitalsCamel, TSubmitVitalsBodyCamel } from '@/types/medwand';
import { TNullable } from '@/types';

export const useMedwandStore = create<IMedwandStore>((set, get) => ({
  vitals: [],
  loading: true,
  vitalsInProgress: false,
  requestAppointmentId: null,
  appointmentId: null,

  setAppointmentId: (appointmentId: TNullable<string>) =>
    set({ appointmentId }),

  setRequestAppointmentId: (requestAppointmentId: TNullable<string>) =>
    set({ requestAppointmentId }),

  setVitalsInProgress: (vitalsInProgress) => {
    set({ vitalsInProgress });
  },

  submitVitals: async (body: TSubmitVitalsBodyCamel) => {
    set({ loading: true });
    try {
      const response = await medwandApi.submitVitals(
        convertKeys(body, 'snake'),
      );
      const vitals: TVitalsCamel = convertKeys(response.data.data);
      get().addVitals(vitals);
    } finally {
      set({ loading: false });
    }
  },

  fetchVitals: async () => {
    set({ loading: true });
    try {
      const response = await medwandApi.getVitals();
      const vitals: TVitalsCamel[] = convertKeys(response.data.data);
      set({ vitals });
    } catch {
      set({ vitals: [] });
    } finally {
      set({ loading: false });
    }
  },

  getVitalsByUserId: (uId) =>
    get().vitals.filter(({ userId }) => userId === uId),

  addVitals: (vitals) =>
    set((state) =>
      state.vitals.some(({ id }) => id === vitals.id)
        ? state
        : { vitals: [vitals, ...state.vitals] },
    ),
}));
